'use client'; // Error components must be Client Components

import { useEffect } from 'react';
import Layout from "@/components/layout/Layout";

export default function Error({
                                  error,
                                  reset,
                              }: {
    error: Error & { digest?: string };
    reset: () => void;
}) {
    useEffect(() => {
        // Log the error to an error reporting service
        console.error(error);
    }, [error]);

    return (
        <Layout headerStyle={1} footerStyle={1}>
            <section className="section-padding">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-lg-6 text-center">
                            <h1 className="ds-3 mb-4">500</h1>
                            <h2 className="mb-4">Something went wrong!</h2>
                            <p className="fs-5 mb-5 text-neutral-500">
                                We apologize for the inconvenience. An unexpected error occurred.
                            </p>
                            <div className="d-flex justify-content-center gap-3">
                                <button
                                    className="btn btn-primary"
                                    onClick={
                                        // Attempt to recover by trying to re-render the segment
                                        () => reset()
                                    }
                                >
                                    Try again
                                </button>
                                <a href="/" className="btn btn-outline-primary">
                                    Go Home
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </Layout>
    );
}